import { gql } from '@apollo/client';

import { lessonFragment } from '../fragments';

export default gql`
  query GetLesson($courseId: String!, $groupId: String!) {
    lessons(courseId: $courseId, groupId: $groupId)
      @rest(
        type: "Lesson"
        path: "courses/{args.courseId}/groups/{args.groupId}/lessons"
      ) {
      ...Lesson
    }
  }
  ${lessonFragment}
`;
